import { SvgProps } from "./Form";

export const ListIcon = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7319_22651)">
      <path
        d="M14.0002 2.33351H4.0835V3.50018H14.0002V2.33351Z"
        fill="currentColor"
      />
      <path
        d="M14.0002 6.4165H4.0835V7.58318H14.0002V6.4165Z"
        fill="currentColor"
      />
      <path
        d="M14.0002 10.5H4.0835V11.6667H14.0002V10.5Z"
        fill="currentColor"
      />
      <path
        d="M1.16667 4.08333C1.811 4.08333 2.33333 3.561 2.33333 2.91666C2.33333 2.27233 1.811 1.75 1.16667 1.75C0.522334 1.75 0 2.27233 0 2.91666C0 3.561 0.522334 4.08333 1.16667 4.08333Z"
        fill="currentColor"
      />
      <path
        d="M1.16667 8.16686C1.811 8.16686 2.33333 7.64452 2.33333 7.00019C2.33333 6.35586 1.811 5.83353 1.16667 5.83353C0.522334 5.83353 0 6.35586 0 7.00019C0 7.64452 0.522334 8.16686 1.16667 8.16686Z"
        fill="currentColor"
      />
      <path
        d="M1.16667 12.2498C1.811 12.2498 2.33333 11.7275 2.33333 11.0831C2.33333 10.4388 1.811 9.91647 1.16667 9.91647C0.522334 9.91647 0 10.4388 0 11.0831C0 11.7275 0.522334 12.2498 1.16667 12.2498Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7319_22651">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
